import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import StudioPage from "@/pages/StudioPage";
import CardLandingPage from "@/pages/CardLandingPage";
import HistoryPage from "@/pages/HistoryPage";
import QuizPage from "@/pages/QuizPage";
import PlaygroundPage from "@/pages/PlaygroundPage";

function App() {
  const [dark, setDark] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("kk-theme");
    const isDark = saved === "dark";
    setDark(isDark);
    document.documentElement.classList.toggle("dark", isDark);
  }, []);

  const toggleTheme = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("kk-theme", next ? "dark" : "light");
  };

  return (
    <div className="App min-h-screen bg-background text-foreground font-sans">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StudioPage dark={dark} toggleTheme={toggleTheme} />} />
          <Route path="/verlauf" element={<HistoryPage dark={dark} toggleTheme={toggleTheme} />} />
          <Route path="/quiz" element={<QuizPage dark={dark} toggleTheme={toggleTheme} />} />
          <Route path="/playground" element={<PlaygroundPage dark={dark} toggleTheme={toggleTheme} />} />
          <Route path="/karte/:cardId" element={<CardLandingPage dark={dark} toggleTheme={toggleTheme} />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
